/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/store/user/local"/>
import {getCurrent} from "Core/Medius.Core.Web/Scripts/Medius/lib/utils/user";
import {createLocalStore} from "Core/Medius.Core.Web/Scripts/Medius/lib/store/async";

export function getFor(prefix: string) {
    const key = `${prefix}:user(${getCurrent().Id})`;
        
    return createLocalStore(key);
}
